// Takuzu / Binairo generator & validator
function shuffle(a) {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

function okPartial(grid, n, r, c) {
  const v = grid[r][c];
  if (c >= 2 && grid[r][c - 1] === v && grid[r][c - 2] === v) return false;
  if (r >= 2 && grid[r - 1][c] === v && grid[r - 2][c] === v) return false;
  let cr = 0;
  for (let j = 0; j < n; j++) if (grid[r][j] === v) cr++;
  if (cr > n / 2) return false;
  let cc = 0;
  for (let i = 0; i < n; i++) if (grid[i][c] === v) cc++;
  if (cc > n / 2) return false;
  return true;
}

function generateSolution(n) {
  const grid = Array.from({ length: n }, () => Array(n).fill(-1));
  function fill(pos) {
    if (pos === n * n) return true;
    const r = Math.floor(pos / n);
    const c = pos % n;
    for (const v of shuffle([0, 1])) {
      grid[r][c] = v;
      if (okPartial(grid, n, r, c) && fill(pos + 1)) return true;
    }
    grid[r][c] = -1;
    return false;
  }
  fill(0);
  return grid;
}

export function makePuzzle(n, givenRatio) {
  const solution = generateSolution(n);
  const puzzle = solution.map((row) => row.slice());
  const cells = shuffle([...Array(n * n).keys()]);
  const toRemove = Math.floor(n * n * (1 - givenRatio));
  for (let k = 0; k < toRemove; k++) {
    const idx = cells[k];
    puzzle[Math.floor(idx / n)][idx % n] = -1;
  }
  return { solution, puzzle };
}

export function checkWin(grid, n) {
  for (let r = 0; r < n; r++) for (let c = 0; c < n; c++) if (grid[r][c] === -1) return false;
  for (let r = 0; r < n; r++) {
    let cnt = 0;
    for (let c = 0; c < n; c++) {
      cnt += grid[r][c];
      if (c >= 2 && grid[r][c] === grid[r][c - 1] && grid[r][c] === grid[r][c - 2]) return false;
    }
    if (cnt !== n / 2) return false;
  }
  for (let c = 0; c < n; c++) {
    let cnt = 0;
    for (let r = 0; r < n; r++) {
      cnt += grid[r][c];
      if (r >= 2 && grid[r][c] === grid[r - 1][c] && grid[r][c] === grid[r - 2][c]) return false;
    }
    if (cnt !== n / 2) return false;
  }
  return true;
}

export function findConflicts(grid, n) {
  const bad = new Set();
  for (let r = 0; r < n; r++)
    for (let c = 0; c < n; c++) {
      const v = grid[r][c];
      if (v === -1) continue;
      if (c >= 2 && grid[r][c - 1] === v && grid[r][c - 2] === v) {
        bad.add(`${r},${c}`); bad.add(`${r},${c - 1}`); bad.add(`${r},${c - 2}`);
      }
      if (r >= 2 && grid[r - 1][c] === v && grid[r - 2][c] === v) {
        bad.add(`${r},${c}`); bad.add(`${r - 1},${c}`); bad.add(`${r - 2},${c}`);
      }
    }
  for (let r = 0; r < n; r++) {
    let z = 0, o = 0;
    for (let c = 0; c < n; c++) { if (grid[r][c] === 0) z++; else if (grid[r][c] === 1) o++; }
    if (z > n / 2 || o > n / 2) for (let c = 0; c < n; c++) if (grid[r][c] !== -1) bad.add(`${r},${c}`);
  }
  for (let c = 0; c < n; c++) {
    let z = 0, o = 0;
    for (let r = 0; r < n; r++) { if (grid[r][c] === 0) z++; else if (grid[r][c] === 1) o++; }
    if (z > n / 2 || o > n / 2) for (let r = 0; r < n; r++) if (grid[r][c] !== -1) bad.add(`${r},${c}`);
  }
  return bad;
}
